<template>
    <ayuda-tema-base
        :busqueda="busqueda"
        :color="color"
        :faqs="faqs"
        video-url="https://share.synthesia.io/embeds/videos/908357a4-6c14-4eec-9ee1-c64565b9a452"
        video-titulo="Visión general del Centro de Reservas"
    />
</template>

<script>
import AyudaTemaBase from './AyudaTemaBase.vue';

export default {
    name: 'AyudaTemaGeneral',
    components: {
        AyudaTemaBase
    },
    props: {
        busqueda: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: '#455A64'
        }
    },
    data() {
        return {
            faqs: [
                {
                    id: 1,
                    pregunta: '¿Qué módulos incluye el Centro de Reservas?',
                    respuesta: `
                        <p>La aplicación se organiza por módulos como ayuda, nueva solicitud, expedientes y cuenta/acceso.</p>
                        <p>Cada uno agrupa funciones concretas del trabajo diario.</p>
                    `,
                    respuestaTexto: 'La aplicación se organiza por módulos como ayuda, nueva solicitud, expedientes y cuenta acceso. Cada uno agrupa funciones concretas del trabajo diario.'
                },
                {
                    id: 2,
                    pregunta: '¿Cómo encuentro rápidamente una funcionalidad dentro de la aplicación?',
                    respuesta: `
                        <p>Usa el menú lateral para cambiar de módulo.</p>
                        <p>En el centro de ayuda encontrarás vídeos y preguntas frecuentes específicas de cada área.</p>
                    `,
                    respuestaTexto: 'Usa el menú lateral para cambiar de módulo. En el centro de ayuda encontrarás vídeos y preguntas frecuentes específicas de cada área.'
                },
                {
                    id: 3,
                    pregunta: '¿Qué hago si un listado o formulario no muestra la información esperada?',
                    respuesta: `
                        <p>Revisa primero:</p>
                        <ul>
                            <li>Filtros activos</li>
                            <li>Paginación actual</li>
                            <li>Campos obligatorios pendientes</li>
                        </ul>
                        <p>Si el problema persiste, contacta con soporte indicando agencia, módulo y contexto del error.</p>
                    `,
                    respuestaTexto: 'Revisa primero filtros activos, paginación actual y campos obligatorios pendientes. Si el problema persiste, contacta con soporte indicando agencia, módulo y contexto del error.'
                }
            ]
        };
    }
};
</script>
